(() => {
  'use strict';
  const KEY = 'avontic-business-quote-draft-v2';
  const PREVIOUS = 'avontic-business-quote-previous-v3';
  const read = key => { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const save = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } };
  const apply = async () => {
    const root = document.querySelector('[data-avb]');
    const form = root?.querySelector('form[data-avb-form], form.avb-quote');
    if (!form || root.querySelector('[data-avb-success-scope]') || root.dataset.avtQuoteReady) return;
    root.dataset.avtQuoteReady = 'true';
    const panels = [...root.querySelectorAll('[data-avt-quote-context]')];
    const text = { ...JSON.parse(panels[0]?.querySelector('[data-avt-quote-text]')?.textContent || '{}'), ...JSON.parse(panels[0]?.querySelector('[data-avt-quote-state-text]')?.textContent || '{}') };
    const extraText = JSON.parse(panels[0]?.querySelector('[data-av17-quote-text]')?.textContent || '{}');
    const labels = {
      saved: root.dataset.quoteSavedLabel || root.dataset.savedLabel || text.selection,
      totalOne: root.dataset.quoteTotalOne || text.total,
      totalOther: root.dataset.quoteTotalOther || text.total,
      packOne: root.dataset.quotePackOne,
      packOther: root.dataset.quotePackOther,
    };
    const field = selector => form.querySelector(selector);
    let previous = read(KEY);
    let savedRequest = Boolean(previous && field('[data-avb-selected-setups]')?.value);
    const totalText = count => (Number(count) === 1 ? labels.totalOne : labels.totalOther).replace('__COUNT__', String(count));
    const packText = (packs, units) => {
      const template = Number(packs) === 1 ? labels.packOne : labels.packOther;
      return template ? template.replace('__PACKS__', String(packs)).replace('__UNITS__', String(units)) : '';
    };
    const templatePattern = template => new RegExp('^' + (template || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      .replaceAll('__COUNT__', '(?<count>\\d+)').replaceAll('__PACKS__', '(?<packs>\\d+)').replaceAll('__UNITS__', '(?<units>\\d+)') + '$');
    const totalPatterns = [text.total, labels.totalOne, labels.totalOther].filter(Boolean).map(templatePattern);
    const packPattern = templatePattern(text.packs);
    // Older drafts retain their original text. Clean their visible summary only;
    // the stored request and submission fields stay intact for recovery.
    const visibleSummary = summary => summary.split('\n').flatMap(line => {
      const value = line.trim();
      if (totalPatterns.some(pattern => pattern.test(value)) || /^Current request: \d+ devices?$/.test(value)) return [];
      const pack = value.match(packPattern) || value.match(/^(?<packs>\d+) packs? × (?<units>\d+) devices? = (?<count>\d+) devices?$/);
      return [pack ? (packText(pack.groups.packs, pack.groups.units) || line) : line];
    }).join('\n').trim();
    panels.forEach(panel => {
      panel.setAttribute('aria-label', text.selection);
      panel.querySelector('.avt-quote-context__title').textContent = text.selection;
      panel.querySelector('[data-avt-quote-previous]').textContent = text.previous_kept;
      ['append', 'resume', 'replace'].forEach(action => { panel.querySelector(`[data-avt-quote-${action}]`).textContent = text[action]; });
    });
    const status = message => panels.forEach(panel => { panel.hidden = false; panel.querySelector('[data-avt-quote-status]').textContent = message; });
    const render = () => {
      const summary = field('[data-avb-selected-setups]')?.value || '';
      const total = field('[data-avb-total-quantity]')?.value || '';
      panels.forEach(panel => {
        if (summary) panel.hidden = false;
        const title = savedRequest ? labels.saved : text.selection;
        panel.setAttribute('aria-label', title);
        panel.querySelector('.avt-quote-context__title').textContent = title;
        panel.querySelector('[data-avt-quote-summary]').textContent = visibleSummary(summary);
        panel.querySelector('[data-avt-quote-total]').textContent = total ? totalText(total) : '';
      });
    };
    root.addEventListener('avontic:quote-updated', render);
    const markEdited = () => { savedRequest = false; render(); };
    form.addEventListener('input', markEdited);
    form.addEventListener('change', markEdited);
    root.querySelector('form.avb-quick__form')?.addEventListener('input', markEdited);
    root.addEventListener('avontic:quote-cleared', () => {
      previous = null;
      savedRequest = false;
      panels.forEach(panel => { panel.querySelector('[data-avt-quote-draft-actions]').hidden = true; });
      render();
    });
    render();
    const params = new URLSearchParams(location.search);
    if (params.get('intent') === 'formal_quote') {
      const quoteOption = root.querySelector('form.avb-quick__form [data-av17-formal-quote]');
      if (quoteOption) quoteOption.selected = true;
      const formalNeed = form.querySelector('[data-avb-procurement-need][value="Formal quote"]');
      if (formalNeed) {
        formalNeed.checked = true;
        formalNeed.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    const productPreference = product => {
      const explicit = params.get('case');
      if ([...form.querySelectorAll('[name="contact[Case preference]"]')].some(input => input.value === explicit)) return explicit;
      if (!product) return 'help';
      if (/workforce/i.test(product.handle)) return 'workforce';
      if (product.handle === root.dataset.proHandle) return 'pro';
      if (product.handle === root.dataset.armorHandle) return 'armorpro';
      return 'other-products';
    };
    const getProduct = async (handle, variantId = '') => {
      const prefix = location.pathname.split('/pages/')[0];
      const url = new URL(prefix + '/products/' + encodeURIComponent(handle), location.origin);
      url.searchParams.set('view', 'avontic-selection');
      if (variantId) url.searchParams.set('variant', variantId);
      ['preview_theme_id', '_fd', 'pb', 'country', 'currency', 'locale'].forEach(key => { if (params.has(key)) url.searchParams.set(key, params.get(key)); });
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error('request');
      const result = await response.json();
      if (result.handle !== handle || variantId && String(result.variant?.id) !== variantId) throw new Error('selection');
      return result;
    };
    const handle = params.get('product');
    const variantId = params.get('variant');
    const planningQuantity = Number(params.get('quantity'));
    const planning = !variantId && Number.isInteger(planningQuantity) && planningQuantity > 0 && planningQuantity <= 100000;
    if (handle && !/^[\p{L}\p{N}™®_-]+$/u.test(handle)) return;
    if (!handle && !planning) return;
    const preference = params.get('case') || handle || 'help';
    if (!variantId && !planning) {
      const choice = [...form.querySelectorAll('[name="contact[Case preference]"]')].find(input => input.value === preference);
      if (choice) { choice.checked = true; choice.dispatchEvent(new Event('change', { bubbles: true })); }
      if (params.get('quantity')) status(text.unverified);
      return;
    }
    if (variantId && !/^\d+$/.test(variantId)) { status(text.unverified); return; }
    let incoming;
    status(text.loading);
    const submits = [...root.querySelectorAll('button[type="submit"]')].map(button => ({ button, disabled: button.disabled }));
    submits.forEach(({ button }) => { button.disabled = true; });
    try {
      if (planning) {
        let devices = [];
        try {
          const candidate = JSON.parse(params.get('devices') || '[]');
          if (Array.isArray(candidate) && candidate.length <= 3 && candidate.every(item => typeof item.model === 'string' && item.model.length <= 180 && Number.isInteger(item.quantity) && item.quantity > 0 && item.quantity <= 100000) && candidate.reduce((sum, item) => sum + item.quantity, 0) === planningQuantity) devices = candidate;
        } catch (_) { /* A plain quantity link can still start a planning request. */ }
        const interest = handle ? await getProduct(handle) : null;
        incoming = { key: 'v4:planning:' + (params.get('source') || '') + ':' + planningQuantity + ':' + (handle || '') + ':' + JSON.stringify(devices), title: interest?.title || '', model: '', planning: true, quantity: planningQuantity, preference: productPreference(interest), devices: devices.length ? devices : undefined,
          summary: [interest ? extraText.planning + ': ' + interest.title : '', interest ? extraText.help : '', ...devices.map(item => item.model + ' × ' + item.quantity)].filter(Boolean).join('\n') };
      } else {
      const product = await getProduct(handle, variantId);
      const variant = product.variant;
      const packCount = Number(params.get('pack_count'));
      const requested = Number(params.get('quantity'));
      const quantity = Number.isInteger(packCount) && packCount > 0 && packCount <= 100000 ? packCount * variant.units : requested;
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100000) throw new Error('quantity');
      const options = product.optionNames.map((name, index) => ({ name, value: variant.options[index] }));
      const variantModel = options.find(option => /model|device|size/i.test(option.name))?.value || '';
      const requestedModel = params.get('source') === 'tablet_builder' ? (params.get('tablet_model') || '').trim() : '';
      const model = requestedModel && requestedModel.length <= 180 && !/[\r\n\x00-\x1f]/.test(requestedModel) ? requestedModel : variantModel;
      const colors = options.filter(option => /colou?r/i.test(option.name)).map(option => `${option.name}: ${option.value}`).join(' / ');
      const aNumber = [params.get('model'), params.get('smartfit_model')].find(value => /^A\d{4}$/.test(value || '') && model.includes(value)) || '';
      const optionText = options.filter(option => option.name !== 'Title').map(option => `${option.name}: ${option.value}`).join(' · ');
      const packs = variant.units > 1 && quantity % variant.units === 0 ? packText(quantity / variant.units, variant.units) : '';
      const itemCount = Number.isInteger(packCount) && packCount > 0 ? packCount : quantity / variant.units;
      const price = Number.isFinite(variant.price) && product.currency ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:product.currency}).format(variant.price / 100) + ' ' + product.currency : '';
      const reference = extraText.variant + ': ' + variantId + (variant.sku ? ' · SKU: ' + variant.sku : '');
      let summary = [product.title, model !== variantModel ? model : '', optionText, packs, extraText.quantity + ': ' + quantity, reference, price ? extraText.price + ': ' + price : '', variant.available ? '' : text.availability].filter(Boolean).join('\n');
      let bundleKey = '';
      if (params.has('items')) {
        const items = JSON.parse(params.get('items'));
        if (!Array.isArray(items) || !items.length || items.length > 12 || !items.every(item => /^[\p{L}\p{N}™®_-]+$/u.test(item.handle || '') && /^\d+$/.test(item.variant || '') && Number.isInteger(item.quantity) && item.quantity > 0 && item.quantity <= 100000)) throw new Error('items');
        if (items[0].handle !== handle || items[0].variant !== variantId || items[0].quantity !== itemCount) throw new Error('base');
        const summaries = await Promise.all(items.map(async (item, index) => {
          if (index === 0) return summary;
          const selected = await getProduct(item.handle, item.variant);
          const selectedOptions = selected.optionNames.map((name, i) => name + ': ' + selected.variant.options[i]).join(' · ');
          return [selected.title + ' × ' + item.quantity, selectedOptions, extraText.variant + ': ' + item.variant + (selected.variant.sku ? ' · SKU: ' + selected.variant.sku : ''), selected.variant.available ? '' : text.availability].filter(Boolean).join('\n');
        }));
        summary = summaries.join('\n\n');
        bundleKey = ':' + JSON.stringify(items);
      }
      incoming = { key: 'v4:' + handle + ':' + variantId + ':' + quantity + bundleKey + (model !== variantModel ? ':' + model : ''), title: product.title, model, colors, aNumber, quantity, preference: productPreference(product), summary };
      }
      const savedKey = previous?.fields?.find(item => item.name === 'contact[Selection key]')?.value;
      if (savedKey === incoming.key) {
        previous = read(PREVIOUS);
        savedRequest = true;
        status(text.restored);
      } else {
        if (previous?.fields?.some(item => item.name === 'contact[Estimated quantity]' && Number(item.value) > 0) || previous?.devices?.some(item => item.model || Number(item.quantity) > 0)) save(PREVIOUS, previous);
        else previous = null;
        const detail = { mode: 'replace', selection: incoming };
        root.dispatchEvent(new CustomEvent('avontic:quote-selection', { detail }));
        if (!detail.applied) throw new Error('form');
        savedRequest = false;
        root.querySelector('form.avb-quick__form')?.setAttribute('data-av17-incoming-quantity', String(incoming.quantity));
        status(planning ? text.planning_loaded : text.loaded);
      }
      panels.forEach(panel => {
        panel.querySelector('[data-avt-quote-draft-actions]').hidden = !previous;
        const run = mode => {
          const detail = { mode, selection: incoming, draft: previous };
          root.dispatchEvent(new CustomEvent('avontic:quote-selection', { detail }));
          if (!detail.applied) { status(text.limit); return; }
          savedRequest = mode === 'resume';
          status(mode === 'resume' ? text.resumed : mode === 'append' ? text.appended : planning ? text.planning_loaded : text.loaded);
          panels.forEach(item => {
            item.querySelector('[data-avt-quote-append]').hidden = mode === 'append';
            item.querySelector('[data-avt-quote-replace]').hidden = mode === 'replace';
          });
          render();
        };
        panel.querySelector('[data-avt-quote-append]').addEventListener('click', () => run('append'));
        panel.querySelector('[data-avt-quote-resume]').addEventListener('click', () => run('resume'));
        panel.querySelector('[data-avt-quote-replace]').addEventListener('click', () => run('replace'));
      });
      render();
    } catch (_) { status(text.unverified); }
    finally { submits.forEach(({ button, disabled }) => { button.disabled = disabled; }); }
  };
  if (document.readyState === 'complete') apply();
  else window.addEventListener('load', apply, { once: true });
})();
